import { defineStore } from 'pinia'
import type { IApiInstance } from '~/plugins/api'
import type { Observation, ObservationStoreItem } from '~/repository/types/observation'
import type { UIObservation } from '~/repository/types/UIObservation'
import _ from 'lodash'

export const useObservationsStore = defineStore('observations', {
  state: () => ({
    cache: {} as Record<string, ObservationStoreItem>,
  }),
  getters: {
    getObservationsByPatientAndCode: (state) => (id: string, code: string) => {
      return state.cache[id] && state.cache[id][code] ? state.cache[id][code] : null
    },
  },
  actions: {
    setObservationsByPatientAndCode(patientId: string, code: string, arr: UIObservation[], nextPageUrl: string | null) {
      if (!this.cache[patientId]) this.cache[patientId] = {}
      if (!this.cache[patientId][code]) this.cache[patientId][code] = { nextPageUrl: null, observations: [] }
      this.cache[patientId][code].nextPageUrl = nextPageUrl
      this.cache[patientId][code].observations = this.cache[patientId][code].observations.concat(arr)
      this.cache[patientId][code].observations = _.orderBy(
        this.cache[patientId][code].observations,
        ['effectiveAt'],
        ['desc'],
      )
    },

    clear() {
      this.$reset()
    },
  },
})
